{
  "back": "Atrás",
  "back_2": "Atrás",
  "back_answering": "Volver a responder",
  "cc": "Este trabajo está bajo licencia Creative Commons Attribution-NonCommercial 4.0 International (CC BY-NC).",
  "conformation_benchmark": "El último punto de referencia se descargará a través de Internet.",
  "conformation_incomplete_q": "Este estado se eliminará. Guarde las respuestas detalladas en el disco local para continuar más tarde.",
  "conformation_internet": "El último cuestionario se descargará a través de Internet.",
  "conformation_internet2": "Los datos se cargarán en la base de datos. La aplicación reenvía la solicitud a través de Internet.",
  "continue": "Continuar",
  "download": "Descargar al disco local",
  "end": "Fin",
  "green": "El atributo es completamente verdadero en el contexto de su organización",
  "incomplete": "¡Quedan algunas preguntas sin respuesta!",
  "version": "Versión del cuestionario",
  "introduction": {
    "apply": "Tras evaluar todas las afirmaciones, el participante recibirá inmediatamente una visión general de la situación del sistema de gestión de la seguridad de la información de su organización en forma de archivo descargable y de gráfico visual. El gráfico contiene diez dimensiones de la gestión de la seguridad de la información que pueden utilizarse para planificar en mayor profundidad la gestión de la seguridad de la información de la organización.",
    "contact": "Póngase en contacto con nosotros si tiene alguna pregunta",
    "data_processing": "Principios del procesamiento de datos:",
    "data_processing_1": "* La dirección de correo electrónico se utiliza únicamente para informar a los participantes cuando se publica una nueva versión del cuestionario o nuevos datos de referencia.",
    "data_processing_2": "* El nombre de la organización es necesario para especificar el dominio, identificar resultados duplicados y monitorear la dinámica de los resultados en evaluaciones repetidas.",
    "data_processing_3": "* Los resultados, promediados por nivel de madurez de seguridad, se analizan y se presentan sin los nombres de las organizaciones participantes.",
    "data_processing_4": "* Los resultados de la evaluación en el contexto de una sola institución solo se utilizarán de forma anónima. Los resultados promedio basados ​​en el dominio, es decir, el área de actividad y el tamaño de la institución, solo se publicarán si los resultados de la medición provienen de al menos cinco instituciones pertenecientes al grupo correspondiente.",
    "data_processing_5": "En cooperación  con el Centro Nacional de Ciberseguridad (RIA,NCSC-EE), los investigadores utilizarán los datos y desarrollarán un dominio basado y un punto de referencia a nivel nacional.",
    "developers": "La estructura de la evaluación de los principios de madurez (F4SLE) es desarrollado por Mari Seeba (UT, RIA). La herramienta de medición (MASS) es desarrollada por Maria Pibilota Murumaa (UT, Cybernetica AS) bajo la supervisión de Mari Seeba y Tarmo Oja. Tarmo Oja (UT, Cybernetica AS), Vaclav Matyas (MUNI) ja Vaclav Stupka (MUNI) están involucrados como expertos. El proyecto de medición es un miniproyecto de CHESS proyecto de colaboración de investigación en Estonia y Moravia del Sur en la República Checa.",
    "disclaimer": "Fundado por la Unión Europea bajo Acuerdo de subvención No. 101087529. Las vistas y opiniones expresadas son aquellas solo del autor (es) y no necesariamente reflejan aquellas de la Unión Europea o de la Agencia Ejecutiva Europea de Investigación. Ni la Unión Europea ni la autoridad concedente puede ser considerada responsable de ellos.",
    "evaluation": "La evaluación esta basada en las Normas de seguridad de la información de Estonia (E-ITS https://eits.ria.ee), Informe sobre el panorama de amenazas de ENISA 2022 (DOI: 10.2824/764318) recomendaciones y portadas  ISO27002:2022 objetivos de control",
    "header": "Evaluación del nivel de madurez de la seguridad de la información de la organización",
    "principle_1": "* Las respuestas detalladas solo existen en el ordenador del encuestado, es decir, en su dispositivo.",
    "principle_2": "* Si acepta transmitir los valores numéricos agregados de la madurez de su organización al servidor, también le proporcionaremos un punto de referencia. El punto de referencia se puede utilizar para comparar los resultados de su organización con los resultados promedio de otras organizaciones (si están disponibles en el servidor en ese momento).",
    "principle_3": "* Es posible guardar las respuestas en su ordenador (consulte el botón \"Inicio\") para continuar respondiendo más tarde o revisar respuestas anteriores.",
    "principle_4": "* Con su consentimiento, solo se transmitirán al servidor los valores numéricos promedio de las respuestas y la información que proporcione sobre la organización. Antes de enviarlos al servidor, puede revisar y guardar los datos que se transmiten.",
    "principles": "Principios:",
    "processor": "Responsable del tratamiento de datos:",
    "time_estimate": "Le agradecemos que evalúe la madurez de la gestión de la seguridad de la información de su organización con nuestra herramienta. Se espera que la finalización del flujo de trabajo tome entre 30 y 70 minutos.",
    "ut": "Universidad de Tartu."
  },
  "invalid_file": "El archivo cargado no es válido. Inténtelo de nuevo.",
  "language": "Selección de idioma",
  "more_info": "Información adicional",
  "new_questionnaire": "Iniciar un nuevo cuestionario",
  "next": "Siguiente",
  "no_answer": "No responde",
  "not_applicable": "No corresponde",
  "orange": "El atributo coincide parcialmente con la descripción de la situación, pero aún presenta deficiencias significativas",
  "red": "Aún no se ha hecho nada significativo para la situación descrita en el atributo",
  "result_upload": "Abrir un archivo de resultados existente desde el disco local",
  "results": {
    "PDF": "Generar PDF",
    "basic": "Básico",
    "basic_description": "Las prácticas funcionan y están documentadas, se planifican los recursos y se asignan funciones y responsabilidades. Aún no se ha logrado la regularidad de las actividades.",
    "basic_description2": "Se han implementado actividades prácticas básicas para gestionar la seguridad de la información",
    "basic_range": ">=1,5 y <2,25 BÁSICO",
    "benchmark_results": "Resultados comparados con el punto de referencia",
    "defined": "Definido",
    "defined_description": "Se inician procesos y actividades de manera ad hoc. Se han preparado documentos pero están parcialmente desactualizados o no corresponden a la realidad.",
    "defined_description2": "Se han acordado procesos formales y se han preparado los documentos de soporte necesarios para la seguridad de la información.",
    "defined_range": ">=0,75 y <1,5 DEFINIDO",
    "goal": "Meta",
    "initial": "Inicial",
    "initial_range": "<0,75 INICIADO",
    "initiated": "INICIADO",
    "initiated_description": "No se han implementado buenas prácticas, no se han reconocido los riesgos y la dirección no ha tomado la iniciativa. Las actividades de seguridad son esporádicas y, en cambio, se inician desde la base.",
    "initiated_description2": "Se ha reconocido y abordado la necesidad de abordar la seguridad de la información.",
    "maturity_levels": "Niveles de madurez",
    "more": "Al enviar los valores numéricos promedio de las respuestas a la base de datos, se mostrarán los resultados promedio de otras organizaciones junto a los resultados de su organización. Para ello, presione el siguiente botón:",
    "process_dim": "Dimensiones del proceso",
    "results": "Resultados",
    "save_local": "Guardar respuestas detalladas en el disco local",
    "save_summary_local": "Guardar metadatos resumidos en el disco local",
    "send_data": "Enviar datos al servidor y cargar puntos de referencia",
    "standard": "Estándar",
    "standard_description": "Las políticas y los principios organizacionales son claros. Las actividades se monitorean y rastrean, y las actividades están estandarizadas y documentadas. Se lleva a cabo una mejora continua. Se monitorean las excepciones.",
    "standard_description2": "Existen políticas y principios organizacionales claros. Las actividades están estandarizadas, documentadas, son regulares y monitoreadas. Hay monitoreo y mejora continuos.",
    "standard_range": ">2.25 ESTÁNDAR",
    "system_dim": "Dimensiones del sistema"
  },
  "send_results": {
    "back": "Atrás",
    "country": "País",
    "czech": "República Checa",
    "db_address": "Dirección de la base de datos",
    "description": "Recolección de datos y retroalimentación",
    "domain": "Dominio organizacional *",
    "domain_list": {
      "ICT": "TIC",
      "chemicals": "Fabricación, producción y distribución de productos químicos",
      "digi": "Proveedores digitales",
      "digital_service": "Infraestructura digital",
      "education": "Educación e investigación",
      "energy": "Energía",
      "finance": "Finanzas",
      "food": "Producción, procesamiento y distribución de alimentos",
      "healthcare": "Asistencia sanitaria",
      "manufactoring": "Fabricación",
      "municipality": "Municipalidad",
      "non-profit": "Sin ánimo de lucro",
      "other": "Otros",
      "postal": "Servicios postales y de mensajería",
      "public_admin": "Administración pública",
      "space": "Espacio",
      "transport": "Transporte",
      "waste": "Gestión de residuos",
      "water_heating": "Agua y calefacción urbana"
    },
    "email": "Correo electrónico (utilizado para notificaciones, p. ej., nuevos puntos de referencia, cuestionarios)",
    "estonia": "Estonia",
    "feedback": "Comentarios",
    "home": "Página de inicio",
    "info_sent": "Vista previa de la información enviada a la base de datos",
    "it_dep": "Número de personas involucradas en la seguridad de la información o la gestión de TI dentro de la organización *",
    "it_dep_explanation": "Cuente a todas las personas que dedican el 50 % o más de su tiempo a trabajar en la gestión de TI o la seguridad de la información.",
    "loading": "Cargando",
    "more_info": "Los principios del procesamiento de datos se pueden encontrar aquí",
    "org_name": "Nombre de la organización *",
    "other_country": "Otro",
    "other_country_2": "Ingrese país *",
    "other_domain": "Ingrese dominio *",
    "other_role": "Ingrese rol *",
    "refuse": "No desea participar en la recopilación de datos",
    "role": "Rol *",
    "role_list": {
      "IT_manager": "Gerente de IT",
      "admin": "Asistente administrativo/abogado/DPO",
      "auditor": "Auditor",
      "info_manager": "Responsable/ especialista de seguridad de la información",
      "management": "Alta dirección",
      "network": "Administrador de red/sistema",
      "other": "Otro"
    },
    "send": "Resultados enviados",
    "send_database": "Resultados enviados a la base de datos",
    "standard": "Normas implementadas",
    "standard_list": {
      "BSI": "BSI IT Grundshutz (German)",
      "CIS": "Controles CIS",
      "CzechAct": "Act on cyber security, no. 181/2014 Coll. (Czech)",
      "EITS": "E-ITS (Estonian)",
      "ISKE": "ISKE (Estonian)",
      "ISO": "ISO/IEC 27001",
      "KYTS": "KüTS (Estonian)",
      "NIST": "NIST CSF"
    },
    "success": "La información se ha enviado satisfactoriamente a la base de datos!",
    "thank_you": "Gracias por su respuesta!",
    "time": "Tiempo tomado",
    "time_estimate": "Tiempo que lleva responder el questionario",
    "time_list": {
      "1_hour": "Alrededor de 1 hora",
      "2_hours": "2 horas",
      "30_minutes": "Alrededor de 30 minutos",
      "4_hours": "2-4 horas",
      "8_hours": "4-8 horas",
      "workday": "Más de 1 día hábil"
    },
    "token": "Token",
    "validation": "Falsa o falta entrada para los valores:",
    "workplaces": "Número de personal *"
  },
  "to_start": "A la página de inicio",
  "unexpected_error": "¡Error inesperado! ¡Guarde las respuestas en el disco local y vuelva a intentarlo más tarde!",
  "unfinished_questionnaire": "Abra un archivo de respuestas existente desde el disco local",
  "upload_file_text": "Seleccione un archivo .txt para abrir:",
  "yellow": "El atributo está razonablemente abordado con su organización, pero tiene algunas deficiencias"
}
